import BaseEvent from './BaseEvent.js';
import { getGUI, getOSM } from '../../OverworldAnimation.js';
import { DOWN, UP, LEFT, RIGHT, MOVE_N_STEPS, END_MOVING } from '../../constants.js';
import OverworldAction from '../OverworldAction.js';
import Pokemon from '../Pokemon.js';

export default class BeforeIForget extends BaseEvent {
    constructor({
        identifier = 'before_i_forget',
        isActive = true,
        complete = false,
        autoComplete = true,
        objectsIdentifiers = ['mom'],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
        this.acquiredPokemon = null;
    }

    static deserialize(data) {
        return new BeforeIForget({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();
        const player = osm.player;
        const mom = this.getObject('mom');
        const gui = getGUI();
        if (osm.shouldSkipOverworldEvents()) {
            osm.script(async () => {
                const nidoranM = await Pokemon.create({
                    id: player.gender === 'boy' ? 29 : 32,
                    level: 5,
                    iv: {
                        hp: 31,
                        attack: 31,
                        defense: 31,
                        specialAttack: 31,
                        specialDefense: 31,
                        speed: 31,
                    },
                });
                this.acquiredPokemon = nidoranM;
                player.acquirePokemon(nidoranM);
            });
            osm.readText(() => `${player.name} received ${this.acquiredPokemon.name}!`);
            osm.finishReading();
            return;
        }
        osm.script(() => {
            player.running = false;
            gui.sprites.player.frames.val = 0;
            mom.showExclamationMark();
        });
        osm.delay(30);
        osm.script(() => {
            mom.direction = DOWN;
            player.direction = UP;
        });
        osm.readText('Oh! I almost forgot!', { speaker: () => mom.name });
        osm.finishReading();
        osm.moveNPCV2(mom, {
            x: player.position.x,
            y: player.position.y - 16,
            z: player.position.z,
        });
        osm.script(() => {
            mom.direction = DOWN;
        });
        osm.readText("Here's your pokemon.", { speaker: () => mom.name });
        osm.continueReading();
        osm.script(async () => {
            const nidoranM = await Pokemon.create({
                id: player.gender === 'boy' ? 29 : 32,
                level: 5,
                iv: {
                    hp: 31,
                    attack: 31,
                    defense: 31,
                    specialAttack: 31,
                    specialDefense: 31,
                    speed: 31,
                },
            });
            this.acquiredPokemon = nidoranM;
            player.acquirePokemon(nidoranM);
        });
        osm.actions.push(
            new OverworldAction({
                startAction: () => {
                    this.acquiredPokemon = player.party[0];
                    osm.context.stateMachineDelay = 90;
                },
                action: () => {
                    osm.overworldText = `${player.name} received ${this.acquiredPokemon.name}!`;
                    if (osm.cursor > osm.overworldText.length) {
                        osm.cursor = osm.overworldText.length;
                    }
                    osm.context.stateMachineDelay -= 1;
                    return osm.context.stateMachineDelay === 0;
                },
                endAction: () => {
                    osm.overworldText = ' ';
                },
            })
        );
        osm.autoContinueReading();
        osm.readText('Have fun!', { speaker: () => mom.name });
        osm.finishReading();
        osm.moveNPCV2(mom, {
            x: player.position.x - 32,
            y: player.position.y - 32,
            z: player.position.z,
        });
    }
}
